/**
 * useCurrentTime Hook
 * Returns the current time that updates automatically every minute.
 * Used for displaying the "now" indicator on calendar views.
 */

import { useState } from 'react';
import { useInterval } from './useInterval';

/** Update interval in milliseconds (1 minute) */
const UPDATE_INTERVAL = 60000;

/**
 * Hook that returns the current Date, updating every minute.
 *
 * @returns Current Date object that updates every minute
 *
 * @example
 * const currentTime = useCurrentTime();
 * const position = calculateTimePosition(currentTime);
 */
export function useCurrentTime(): Date {
  const [currentTime, setCurrentTime] = useState<Date>(() => new Date());

  useInterval(() => {
    setCurrentTime(new Date());
  }, UPDATE_INTERVAL);

  return currentTime;
}

export default useCurrentTime;
